import APPCONFIG from '../../../constants/Config';
import {
  CPM_GET_CARPARK_CUSTOMER_LF,
  CPM_GET_CARPARK_PARKING_LF,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize as deserializeCustomer } from '../../../models/cpm/customer';
import { deserialize as deserializeParking } from '../../../models/cpm/parking';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmListFilter;
const listFilter = (state = initialSettings, action) => {
  switch (action.type) {
    // CARPARK CUSTOMERS
    case CPM_GET_CARPARK_CUSTOMER_LF:
      return {
        ...state,
        customer: {
          ...state.customer,
          loading: true,
          data: null,
        },
      };
    case `${CPM_GET_CARPARK_CUSTOMER_LF}_SUCCESS`:
      return {
        ...state,
        customer: {
          ...state.customer,
          loading: false,
          data: deserializeCustomer(action.data.getCustomer),
        },
      };
    // CARPARK PARKINGS
    case CPM_GET_CARPARK_PARKING_LF:
      return {
        ...state,
        parking: {
          ...state.parking,
          loading: true,
          data: null,
        },
      };
    case `${CPM_GET_CARPARK_PARKING_LF}_SUCCESS`:
      return {
        ...state,
        parking: {
          ...state.parking,
          loading: false,
          data: deserializeParking(action.data.getParking),
        },
      };
    default:
      return state;
  }
};

export default listFilter;



// WEBPACK FOOTER //
// ./reducers/cpm/listFilter/listFilter.js